import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  assignPapersLoading: false,
  error: null,
  papers: [],
  storePaper: {},
  storeAssignPaper: {},
  assignPaper: [],
  weekdays: [],
  papersList: [],
  paperWeekdays: [],
  deleteAssignPaper: null,
};
const papersSlice = createSlice({
  name: 'papers',
  initialState,
  reducers: {
    loadPapersRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadPapersSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.papers = action?.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadPapersFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    // **** Assign Paper

    storeAssignPaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeAssignPaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeAssignPaper = action.payload;
    },
    storeAssignPaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadAssignPaperRequested(state, action: PayloadAction<{}>) {
      state.assignPapersLoading = true;
      state.error = null;
      state.assignPaper = [];
    },
    loadAssignPaperSuccess(state, action: PayloadAction<any>) {
      state.assignPapersLoading = false;
      state.error = null;
      state.assignPaper = action?.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadAssignPaperFail(state, action: PayloadAction<{}>) {
      state.assignPapersLoading = false;
      state.error = action.payload;
    },

    updateAssignPaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateAssignPaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateAssignPaper = action.payload;
    },
    updateAssignPaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    deleteAssignPaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteAssignPaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteAssignPaper = action.payload;
    },
    deleteAssignPaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    // ************************

    loadPapersListRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadPapersListSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.papersList = action?.payload?.result;
    },
    loadPapersListFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    storePaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storePaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storePaper = action.payload;
    },
    storePaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    updatePaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updatePaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updatePaper = action.payload;
    },
    updatePaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    deletePaperRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deletePaperSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deletePaper = action.payload;
    },
    deletePaperFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadWeekdaysRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadWeekdaysSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.weekdays = action.payload.result;
    },
    loadWeekdaysFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadPaperWeekdaysRequested(state, action: PayloadAction<any>) {
      state.loading = true;
      state.error = null;
    },
    loadPaperWeekdaysSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.paperWeekdays = action.payload.result;
    },
    loadPaperWeekdaysFail(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadPapersRequested,
  loadPapersSuccess,
  loadPapersFail,
  loadAssignPaperRequested,
  loadAssignPaperSuccess,
  loadAssignPaperFail,
  loadPapersListRequested,
  loadPapersListSuccess,
  loadPapersListFail,
  storePaperRequested,
  storePaperSuccess,
  storePaperFail,
  storeAssignPaperRequested,
  storeAssignPaperSuccess,
  storeAssignPaperFail,
  updatePaperRequested,
  updatePaperSuccess,
  updatePaperFail,
  updateAssignPaperRequested,
  updateAssignPaperSuccess,
  updateAssignPaperFail,
  deletePaperRequested,
  deletePaperSuccess,
  deletePaperFail,
  deleteAssignPaperRequested,
  deleteAssignPaperSuccess,
  deleteAssignPaperFail,
  loadWeekdaysRequested,
  loadWeekdaysSuccess,
  loadWeekdaysFail,
  loadPaperWeekdaysRequested,
  loadPaperWeekdaysSuccess,
  loadPaperWeekdaysFail,
} = papersSlice.actions;

export default papersSlice.reducer;
